// 特种箱杂散页面API接口
import {http} from '@/utils/index'

// 获取特种箱杂散页面所有数据
export const getSpecialContainerData = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/data", {
    params
  })
}

// 获取特种箱杂散页面配置
export const getSpecialContainerConfig = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/config", {
    params
  })
}

// 获取特种箱杂散横幅配置
export const getSpecialContainerBanner = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/banner", {
    params
  })
}

// 获取特种箱杂散公司实力配置
export const getSpecialContainerStrength = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/strength", {
    params
  })
}

// 获取特种箱杂散服务优势配置
export const getSpecialContainerAdvantages = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/advantages", {
    params
  })
}

// 获取特种箱杂散集装箱代理配置
export const getSpecialContainerAgency = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/agency", {
    params
  })
}

// 获取特种箱杂散项目管理配置
export const getSpecialContainerProject = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/project", {
    params
  })
}

// 获取特种箱杂散公司资质配置
export const getSpecialContainerQualification = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/qualification", {
    params
  })
}

// 获取特种箱杂散服务范围配置
export const getSpecialContainerScope = (language = null) => {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/special-container/scope", {
    params
  })
}
